import React, { useEffect, useRef, useState } from 'react';
import { useSpring, animated } from 'react-spring';
import { useScrollPosition } from '../../../hooks';

type Props = {
  className?: string;
};

const FSRWorkflow: React.FC<Props> = ({ className }) => {
  const [start, setStart] = useState(false);
  const animationRef = useRef();
  const [first_step_props, set] = useSpring(() => ({
    opacity: 0,
    delay: 1000,
    from: { opacity: 0 },
  }));

  const [second_step_props, set2] = useSpring(() => ({
    opacity: 0,
    from: { opacity: 0 },
    delay: 2000,
  }));

  const [third_step_props, set3] = useSpring(() => ({
    opacity: 0,
    from: { opacity: 0 },
    delay: 3000,
  }));

  const [reorder_step_props, set4] = useSpring(() => ({
    opacity: 0,
    from: { opacity: 0 },
    delay: 4000,
  }));
  useScrollPosition(
    ({ currPos }) => {
      if (currPos.y < -500) {
        if (!start) {
          setStart(true);
        }
      }
    },
    [start],
    animationRef,
  );

  useEffect(() => {
    if (start) {
      set({
        reset: true,
        immediate: false,
        opacity: 1,
        from: { opacity: 0 },
        delay: 500,
      });
      set2({
        reset: true,
        immediate: false,
        opacity: 1,
        from: { opacity: 0 },
        delay: 2000,
      });

      set3({
        reset: true,
        immediate: false,
        opacity: 1,
        from: { opacity: 0 },
        delay: 3000,
      });

      set4({
        reset: true,
        immediate: false,
        opacity: 1,
        from: { opacity: 0 },
        delay: 4000,
      });
    }
  }, [start, set, set2, set3, set4]);

  // @ts-ignore

  return (
    <>
      <div
        className={`bg-gray-900 opacity-100 z-0 relative `}
        style={{ marginLeft: '-50vw', marginRight: '-50vw' }}
      >
        <div
          className={`use_case_workflow z-0 relative`}
          style={{ marginLeft: '25vw', marginRight: '25vw' }}
        >
          <div
            className={`bg-gray-800 z-0 relative ${className}`}
            style={{ background: 'rgba(0, 0, 0, 0.60)' }}
          >
            <div
              className={' z-20 relative'}
              style={{ marginLeft: '25vw', marginRight: '25vw' }}
            >
              <div className="max-w-7xl mx-auto py-16  lg:py-24 relative opacity-100">
                <div className="max-w-3xl mx-auto text-left">
                  <h2 className="text-base text-primary-600 font-semibold tracking-wide uppercase ">
                    How does it work?
                  </h2>
                  <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-white sm:text-4xl ">
                    {/* Built on modern technologies, with restaurants at heart */}{' '}
                    The modern order & payment process to empower dine-in.
                  </p>
                </div>
                <div className={' flex-1 mt-14'}>
                  {
                    <nav aria-label="Progress">
                      <ol className="space-y-4 md:flex md:space-y-0 md:space-x-8">
                        <animated.li
                          className="md:flex-1"
                          style={first_step_props}
                        >
                          <span className="group pl-4 py-2 flex flex-col border-l-4 border-primary-600  md:pl-0 md:pt-4 md:pb-0 md:border-l-0 md:border-t-4">
                            <span className="text-md text-primary-600 font-semibold uppercase ">
                              Step 1
                            </span>
                            <span className="text-xl font-medium text-white">
                              Guest scans QR code
                            </span>
                          </span>
                        </animated.li>

                        <animated.li
                          className="md:flex-1"
                          style={second_step_props}
                        >
                          <span
                            className="pl-4 py-2 flex flex-col border-l-4 border-primary-600 md:pl-0 md:pt-4 md:pb-0 md:border-l-0 md:border-t-4"
                            aria-current="step"
                          >
                            <span className="text-md text-primary-600 font-semibold uppercase">
                              Step 2
                            </span>
                            <span className="text-xl font-medium text-white">
                              Selects menu items
                            </span>
                          </span>
                        </animated.li>

                        <animated.li
                          className="md:flex-1"
                          style={third_step_props}
                        >
                          <span className="group pl-4 py-2 flex flex-col border-l-4 border-primary-600  md:pl-0 md:pt-4 md:pb-0 md:border-l-0 md:border-t-4">
                            <span className="text-md text-primary-600 font-semibold uppercase ">
                              Step 3
                            </span>

                            <span className="text-xl font-medium text-white">
                              Places order
                            </span>
                          </span>
                        </animated.li>
                        <animated.li className={''} style={reorder_step_props}>
                          <div className="flex items-center justify-center h-10 w-10 md:-mt-4 rounded-md bg-primary-600 text-white">
                            <svg
                              className="flex-shrink-0 h-6 w-6 text-white"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                              />
                            </svg>
                          </div>
                          <div className="mt-3">
                            <span className="text-xl font-medium text-white">
                              Orders Again!
                            </span>
                          </div>
                        </animated.li>
                      </ol>
                    </nav>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FSRWorkflow;
